<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${compId ? 'Edit' : 'Add New'} Component`" />
    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="compId" class="custom-label">ID</label>
            <input id="compId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Physical ID</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text" v-model="saveData.physicalid"
             :readonly="compId ? true : false" >
          </div>
              <small v-if="!saveData.physicalid" style="font-size: 10px; color: red;">Enter a text</small>

        </div>
        <div class="row align-items-center ">
          <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Parent Component</label>
              <div class="custom-multiple-dropdown-wrapper">
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.parentid">
                  <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                  <option v-for="component in components" :key="component.uuid" :value="component.uuid">{{ component.name }}
                  </option>
                </select>
                <button @click="updateSelectedParentComponent(saveData.parentid)" class="multiple-dropdown-add-button">+</button>
              </div>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div v-if="selectedParentComponents.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(comp, index) in selectedParentComponents" :key="index">
                <span class="custom-multiple-dropdown">{{ comp }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedParentComponents(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
        
        </div>

        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Component Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.componenttypeid">
              <option v-for="compType in compTypes" :key="compType.uuid" :value="compType.uuid">{{ compType.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">OS</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.osid">
              <option v-for="os in osOptions" :key="os.uuid" :value="os.uuid">{{ os.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Hub </label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.hubid">
              <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label class="custom-label">Asset</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.assetid">
              <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Description</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description"></textarea>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.compId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.compId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.compId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" @click="addCompData()" :disabled="!saveData.physicalid">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addComponent, ddComponentType, ddOs, ddHub, ddAsset, getByComponent, updateComponent } from '@/http/hub-sensors/component.http'
import {  ddComponent } from '@/http/hub-sensors/device.http'
import deleteModal from '@/components/delete-modal.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'component-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      breadcrumsfirst: "Hub & Sensors",
      breadcrumslast: "Component",
      compId: this.$route.params.id,
      compTypes: [],
      osOptions: [],
      assets: [],
      components: [],
      selectedParentComponents: [],
      saveData: {
      parentid: ''
      },
    }
  },
  async mounted() {
    await this.getCompDropdownData();
    await this.getAssetDropdownData();
    await this.getHubDropdownData();
    await this.getOsDropdownData();
    await this.getCompTypeDropdownData();
    await this.getDetailData();
  },
  // computed: {
  //   isSubmitDisabled() {
  //     return this.selectedParentComponents.length === 0;
  //   }
  // },
  methods: {
    addCompData() {
      if (this.compId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        const selectedCompIds = this.selectedParentComponents.map(parentid => {
          const comp = this.components.find(comp => comp.name === parentid);
          return comp ? comp.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.parentid = selectedCompIds;
        updateComponent({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/hubsensors/component")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        const selectedCompIds = this.selectedParentComponents.map(parentid => {
          const comp = this.components.find(comp => comp.name === parentid);
          return comp ? comp.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.parentid = selectedCompIds;
        addComponent(this.saveData).then(() => {
          this.$router.push("/hubsensors/component")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    async getCompDropdownData() {
      try {
        this.components = await ddComponent();
      } catch (error) {
        console.error('Error fetching components :', error);
      }
    },
    async getCompTypeDropdownData() {
      try {
        const response = await ddComponentType();
        this.compTypes = response;
        if (this.compTypes.length > 0) {
          if (this.compId) {
            const index = this.compTypes.findIndex(compType => compType.uuid === this.saveData.componenttypeid);
            if (index !== -1) {
              this.saveData.componenttypeid = this.compTypes[index].uuid;
            }
          } else {
            this.saveData.componenttypeid = this.compTypes[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Component:', error);
      }
    },
    async getOsDropdownData() {
      try {
        const response = await ddOs();
        this.osOptions = response;
        if (this.osOptions.length > 0) {
          if (this.compId) {
            const index = this.osOptions.findIndex(os => os.uuid === this.saveData.osid);
            if (index !== -1) {
              this.saveData.osid = this.osOptions[index].uuid;
            }
          } else {
            this.saveData.osid = this.osOptions[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching OS:', error);
      }
    },
    async getHubDropdownData() {
      try {
        const response = await ddHub();
        this.hubs = response;
        if (this.hubs.length > 0) {
          if (this.compId) {
            const index = this.hubs.findIndex(hub => hub.uuid === this.saveData.hubid);
            if (index !== -1) {
              this.saveData.hubid = this.hubs[index].uuid;
            }
          } else {
            this.saveData.hubid = this.hubs[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Hub:', error);
      }
    },
    async getAssetDropdownData() {
      try {
        const response = await ddAsset();
        this.assets = response;
        if (this.assets.length > 0) {
          if (this.compId) {
            const index = this.assets.findIndex(asset => asset.uuid === this.saveData.assetid);
            if (index !== -1) {
              this.saveData.assetid = this.assets[index].uuid;
            }
          } else {
            this.saveData.assetid = this.assets[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching Asset:', error);
      }
    },
    async getDetailData() {
      if (this.compId) {
        try {
          const response = await getByComponent(this.compId);
          this.saveData = response;
          this.saveData.assetid = response.assetid;
          this.saveData.hubid = response.hubid;
          this.saveData.osid = response.osid;
          this.saveData.componenttypeid = response.componenttypeid;
           if (Array.isArray(response.parentid) && response.parentid.length > 0) {
            this.selectedParentComponents = response.parentid.map(parentid => {
              const parentComp = this.components.find(type => type.uuid === parentid);
              return parentComp ? parentComp.name : '';
            });
            this.saveData.parentid = '';
          } else {
            this.saveData.parentid = '';
          }
        } catch (error) {
          console.error('Error fetching detail data:', error);
        }
      }
    },
    cancelButton() {
      this.$router.push("/hubsensors/component")
    },
    updateSelectedParentComponent(parentid) {
      const comp = this.components.find(comp => comp.uuid === parentid);
      if (comp && !this.selectedParentComponents.includes(comp.name)) {
        this.selectedParentComponents.push(comp.name);
      }
    },
    removeSelectedParentComponents(index) {
      this.selectedParentComponents.splice(index, 1);

    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateComponent({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/hubsensors/component")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>